import React, { Component } from 'react';
import classes from './ResetAccount.css';
import { connect } from 'react-redux';
import Modal from '../../../../UI/Modal/Modal';
import Button from '../../../../UI/Button/Button';
import Spinner from '../../../../UI/Spinner/Spinner';
import * as actions from '../../../../store/actions/index';
import Message from '../../../../components/Message/Message';
import MemberPopUp from '../../MemberAccount/PersonalInfo/MemberPopUp';
import { isAccountDisabled } from '../../../../shared/utility';
import { LOCKED, SESSION_BASELINEAGENT, VERIFIED } from '../../../../shared/Constants';
import { PHONE_NO_AS_RECOVERY_TOOLTIP_MESSAGE, RBALOCK_MUST_BE_FULLY_UNLOCKED_TOOLTIP_MESSAGE } from '../../../../shared/AdminToolMessages';

export class AccountStatus extends Component {

    state = {
        showModal: false,
        popUpMessage: null,
        message: null,
        errMessage: null,
        submitButton: null,
        formData: null,
        formHeader: null,
        genTokenResponse: null,
        smsOtpMessage: null
    }

    toggleModalHandler = () => {
        this.setState({showModal: !this.state.showModal});
    }

    resetPassword = () => {
        let formData = {
            email : this.props.member.essoData.email.value,
            uuid : this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
            userName: this.props.member.essoData?.userName
        }
        this.setState({formData: formData, showModal: true, submitButton: "resetPW", formHeader: "Self-Service Link Reset Password"});
    }

    resetSecurityQues = () => {
        let formData = {
            email : this.props.member.essoData.email.value,
            uuid : this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
            phoneAvailable : this.props.member.essoData.phone.number ? true : false,
            securityQues : this.props.member.essoData.credential && this.props.member.essoData.credential.securityQuestionAndAnswers ? true : false,
            accStatus : this.props.member.essoData.accountStatus.aaStatus,
            userName : this.props.member.essoData.userName,
            headless: this.props.isHeadlessUser,
        }
        this.setState({formData: formData, showModal: true, submitButton: "resetSQ", formHeader: "Self-Service Link Reset Account Recovery Options"});
    }

    verifyEmail = () => {
        let formData = {
            email: this.props.member.essoData.email.value,
            phoneNumber: "",
            uuid: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid
        }
        this.setState({formData: formData, showModal: true, submitButton: "verifyEmail", formHeader: "Email Member a Notification of Change"});
    }

    verifyPhone = () => {
        let formData = {
            email: this.props.member.essoData.email.value,
            phoneNumber: this.props.member.essoData.phone.number,
            countryCode: this.props.member.essoData?.phone?.countryCode,
            uuid: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid
        }
        this.setState({formData: formData, showModal: true, submitButton: "verifyPhone", formHeader: "Email Member a Notification of Change"});
    }

    disableSecurityQuestion = (phoneUpdate) => {
        let disable = false;
        //Disable if the account is locked
        if(this.props.member.essoData.accountStatus.aaStatus === LOCKED
           || !this.props.member.essoData.email){
            disable = true;
        }
        //Disable if the account is verfied but locked due to security questions and there's no phone number
        else if((this.props.member.essoData.accountStatus.aaStatus === VERIFIED
            && (this.props.member.essoData.credential && !this.props.member.essoData.credential.securityQuestionAndAnswers && !this.props.member.essoData.phone.number))){
            disable = true;
        }
        //Disable if the account status is disabled as per esso data of the person
        else if(isAccountDisabled(this.props.member.essoData)){
            disable = true;
        }
        //Disable if the person has a phone number as per data received from esso and it isn't getting updated
        else if (this.props.member.essoData.phone.number){
            disable = true;
        }
        //Disable if the person's phone isn't verified as per data received from esso or, the phone# got updated but not verified
        else if((this.props.member.essoData?.phone.verified===false)
        || (this.props.memResponse && this.props.memResponse.phoneUpdated === true && this.props.memResponse.phoneVerified === false)){
            disable = true;
        }
        return disable;
    }

    generateOtpToken = (otpType) => {
      if (otpType === 'Phone') {
          let formData = {
             uuid: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
             phoneNo: this.props.member.essoData.phone.number,
            phoneType: this.props.member.essoData.phone.label === 'MOBILE' ? "true" : "false",
            userId:this.props.member.essoData.userName,
            countryCode: this.props.member.essoData?.phone?.countryCode
      }
       //console.log("sending otp to sms");
        this.props.generateSmsOtpToken(formData);
      } else {
          let formData = {
           userId: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
           emailId: this.props.member.essoData.email.value,
           userName:this.props.member.essoData.userName
         }
         //console.log("sending otp to email");
        this.props.generateEmailOtpToken(formData);
  }
}
    isResetPasswordDisabled() {
        /*
            It should be disabled if the user is a headless user
            It should be disabled if the RBA is locked
            It should be disabled if the status is verified but no credential exists neither securtityQuestion nor phone number
            It should be disabled if the enable disable status is disabled
        */
        /* return this.props.isHeadlessUser 
            || this.props.member.essoData.accountStatus.aaStatus === LOCKED 
            || (this.props.member.essoData.accountStatus.aaStatus === VERIFIED && (this.props.member.essoData.credential && !this.props.member.essoData.credential.securityQuestionAndAnswers && !this.props.member.essoData.phone.number)) 
            || isAccountDisabled(this.props.member.essoData)
            || !this.props.member.essoData.email */
        // Disabling this button as a fix for US1297810   
        return true;
    }

    getToolTipMessage = () => {
        const recoveryOptionExists = (
            this.props.member.essoData.accountStatus.aaStatus === VERIFIED &&
            (
                (this.props.member.essoData.credential &&
                    this.props.member.essoData.credential.securityQuestionAndAnswers &&
                    this.props.member.essoData.credential.securityQuestionAndAnswers.length === 3)
                || (this.props.member.essoData.phone &&
                    this.props.member.essoData.phone.number)
            )
        );
        return this.props.member.essoData.accountStatus.aaStatus === LOCKED ||  !recoveryOptionExists  ? 
        RBALOCK_MUST_BE_FULLY_UNLOCKED_TOOLTIP_MESSAGE : PHONE_NO_AS_RECOVERY_TOOLTIP_MESSAGE;
    }

    render () {
        const modalWindowEmpty = this.props.otpSpinnerProcessing?(
            <Modal show={this.props.otpSpinnerProcessing}>
                <Spinner/>
            </Modal>
        ):null;

        const modalWindow = this.state.showModal || this.props.spinnerProcessing?(
            <Modal show={this.state.showModal || this.props.spinnerProcessing} modalClosed={this.toggleModalHandler}>
                {this.props.spinnerProcessing?<Spinner/>:
                <MemberPopUp
                    formData={this.state.formData}
                    portalsList = {this.props.portalsList}
                    portalsInfo = {this.props.portalsInfo}
                    setMemPopUpDisplayMessage = {this.props.setMemPopUpDisplayMessage}
                    popUpMessage = {this.props.popUpMessage}
                    submitHandler = {this.props.submitHandler}
                    closeModal = {this.toggleModalHandler}
                    submitButton = {this.state.submitButton}
                    modalSpinnerStart = {this.props.modalSpinnerStart}
                    resetPassword = {this.props.resetPassword}
                    resetSecurityQues = {this.props.resetSecurityQues}
                    verifyEmailorPhone = {this.props.verifyEmailorPhone}
                    formHeader = {this.state.formHeader}
                    agentUserType = {this.props.user.userType}
                    idType = {this.props.member.idType}
                    disabledPortals={this.props.disabledPortals}
                />}
            </Modal>
        ):null;

        let resetButtons = (
            <React.Fragment>
                <div className={classes.RowSplit}>
                    <label className={classes.RowLabel}>Email Password Reset Link</label>
                    <Button id="resetPasswordSend" btnType="ResetVerify" clicked={this.resetPassword} disabled={this.isResetPasswordDisabled()}>Send</Button>
                </div>
                <div className={classes.RowSplit}>
                    <label className={classes.RowLabel}>Email &amp; Reset Security Questions Link</label>
                    <Button id="resetAccountSend" btnType="ResetVerify" clicked={this.resetSecurityQues} disabled={this.disableSecurityQuestion(this.props.phoneUpdated)}>{this.disableSecurityQuestion(this.props.phoneUpdated)?<span data-tip={this.getToolTipMessage()}>Send</span>:<span>Send</span>}</Button>
                </div>
            </React.Fragment>

        );

        const message = this.props.message?<Message msgType={this.props.message.type} info={this.props.message.info}/>:null;
        const errMessage = this.props.errMessage?<Message msgType={this.props.errMessage.type} info={this.props.errMessage.info}/>:null;

        return (
            <div className={classes.ResetAccount}>
                <div className={classes.FormTitle}>Send Member Self-Service Link(s)</div>
                {modalWindow}
                {modalWindowEmpty}
                {message}
                {errMessage}
                {resetButtons}
        </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        member: state.member.member,
        portalsList: state.personalInfo.portals,
        portalsInfo: state.personalInfo.portalsInfo,
        spinnerProcessing: state.member.spinnerProcessing,
        otpSpinnerProcessing: state.member.otpSpinnerProcessing,
        message: state.member.resetAccountMessage,
        errMessage: state.member.resetAccountErrMessage,
        popUpMessage: state.personalInfo.popUpMessage,
        genTokenResponse: state.member.genTokenResponse,
        smsOtpMessage: state.member.smsOtpMessage,
        memResponse: state.member.memResponse,
        user: state.usr.user,
        disabledPortals: state.addEligibility.disabledPortals
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        modalSpinnerStart: () => dispatch(actions.modalSpinnerStart()),
        resetPassword: (userData) => dispatch(actions.resetPassword(userData)),
        resetSecurityQues: (userData) => dispatch(actions.resetSecurityQues(userData)),
        verifyEmailorPhone: (userData) => dispatch(actions.verifyEmailorPhone(userData)),
        setMemPopUpDisplayMessage: (message) => dispatch(actions.setMemPopUpDisplayMessage(message)),
        generateEmailOtpToken: (userData) => dispatch(actions.generateEmailOtpToken(userData)),
        generateSmsOtpToken: (userData) => dispatch(actions.generateSmsOtpToken(userData)),
        verifySmsOtpToken: (userData, essoDetails) => dispatch(actions.verifySmsOtpToken(userData, essoDetails)),
        verifyEmailOtpToken: (userData) => dispatch(actions.verifyEmailOtpToken(userData)),
        setOtpDisplayMessage: (message) => dispatch(actions.setOtpDisplayMessage(message))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountStatus);
